import script from "./base.form.vue?vue&type=script&lang=ts&setup=true"
export * from "./base.form.vue?vue&type=script&lang=ts&setup=true"

import "./base.form.vue?vue&type=style&index=0&id=6d415a81&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d415a81"]])

export default __exports__